module.exports = __webpack_public_path__ + "img/resource.41e4ac87.svg";